import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { CandidateComment } from '../../../class/candidate-comment';
import { CandidateCommentService } from '../../../service/candidate-comment/candidate-comment.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-candidate-comment',
  templateUrl: './new-candidate-comment.component.html',
  styleUrls: ['./new-candidate-comment.component.scss']
})
export class NewCandidateCommentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: CandidateComment;
    @Input() new: CandidateComment;
    @Input() idCandidate: number;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public observations: AbstractControl;
    public candidate_id: AbstractControl;
    public created_by_id: AbstractControl;
    public created_at: AbstractControl;
    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public openingStationService: CandidateCommentService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {
    
        this.save_exit = false;

        this.form = fb.group({
            'candidate_id': [''],
            'created_by_id': [''],
            'observations': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'created_at': [{value: '', disabled: true}],
        });

        this.candidate_id = this.form.controls['candidate_id'];
        this.created_by_id = this.form.controls['created_by_id'];
        this.observations = this.form.controls['observations'];
        this.created_at = this.form.controls['created_at'];
    }

    ngOnInit() {
        if (this.edit) {
            // this.candidate_id.setValue(this.edit.candidate_id);
            this.created_by_id.setValue(this.edit.created_by.name);
            this.observations.setValue(this.edit.observations);
            this.created_at.setValue(this.edit.created_at);
        }
    }

    public cancelCandidateComment () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newCandidateComment(values);
    }

    public newCandidateComment(values) {
        let candidate = values.candidate_id.id;
        if (this.idCandidate) {
            candidate = this.idCandidate;
        }

        const param = {
            'candidate_id': candidate,
            'observations': values.observations,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.openingStationService.updateCandidateComment(this.edit.id, param)
                :
                this.openingStationService.newCandidateComment(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }


    public checkOtherValidation (values) {
        let check = false;
        if (values) {
            if (values.candidate_id) {
                if (values.candidate_id.id) {
                    check = true;
                } else {
                    return false;
                }
            } if (this.idCandidate) {
                check = true;
            }
        }
        return check;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidate-comments/new-candidate-comment/new-candidate-comment.component.ts